import axios from './network.js'

let personCenterAPI = {

  // 收货地址
  addressList: function (data, success, failure) {
    return axios.postJson("Home/User/addressList", data, success, failure);
  },
  // 添加收货地址
  addAddress: function (data, success, failure) {
    return axios.postJson("Home/User/addAddress", data, success, failure);
  },
  // 修改收货地址
  updateAddress: function (data, success, failure) {
    return axios.postJson("Home/User/updateAddress", data, success, failure);
  },
  // 删除收货地址
  deleteAddress: function (data, success, failure) {
    return axios.postJson("Home/User/deleteAddress", data, success, failure);
  },
  // 设置默认地址 
  setDefault: function (data, success, failure) {
    return axios.postJson("Home/User/setDefault", data, success, failure);
  },
  // 获取用户信息
  getUserInfo: function (data, success, failure) {
    return axios.postJson("Home/User/getUserInfo", data, success, failure);
  },
  // 修改个人信息
  updateUserInfo: function (data, success, failure) {
    return axios.postJson("Home/User/updateUserInfo", data, success, failure);
  },
  // 发送修改手机号验证码邮件
  sendUpdateMobileEmail: function (data, success, failure) {
    return axios.postJson("Home/Login/sendUpdateMobileEmail", data, success, failure);
  },
  // 我的帖子
  getUserBlog: function (data, success, failure) {
    return axios.postJson("Home/User/getUserBlog", data, success, failure);
  },
  // 我回复的
  myComment: function (data, success, failure) {
    return axios.postJson("Home/User/myComment", data, success, failure);
  },
  // 个人优惠券列表
  getUserCoupon: function (data, success, failure) {
    return axios.postJson("Home/Coupon/getUserCoupon", data, success, failure);
  },
}

export default personCenterAPI



// WEBPACK FOOTER //
// ./src/api/personCenterAPI.js